// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@models';

export const environment: Environment = {
  name: 'develop',
  production: false,

  remoteApi: 'https://app-casino-event-gw-dev.azurewebsites.net/api',
  sentryEnvironment: 'dev',
};
